import dayjs from "dayjs"
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
// import "@assets/SourceHanSansSC-normal.js"
// import "@assets/SourceHanSansSC-bold.js"
// 字体压缩
// https://github.com/iizyd/SourceHanSansCN-TTF-Min
// https://github.com/parallax/jsPDF/tree/master/fontconverter
import "@assets/tine-regular-normal.js"
import "@assets/tine-medium-bold.js"
function uniqueByField(arr, field) {
    const seen = new Set();
    return arr.filter(item => {
        const value = item[field];
        if (seen.has(value)) {
            return false;
        }
        seen.add(value);
        return true;
    });
}
const logo = "data:image/png;base64,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"

const defaultRecords = [
    {
        "groupKey": "469_验证bug",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2025-11-04T10:35:36.248Z",
        "deliveryVersion": "验证bug",
        "totalWaitPayCount": 3,
        "totalCheckoutTotal": 150,
        "demandItems": [
            {
                "demandId": -1,
                "price": "50",
                "demandName": "综合服务"
            }
        ],
        "waitPayCount": 3,
        "deductAmount": 50,
        "checkoutTotal": 150,
        "remark": "",
        "rowSpan": 1
    },
    {
        "groupKey": "469_冬日第8次交付",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2025-11-11T06:09:21.637Z",
        "deliveryVersion": "冬日第8次交付",
        "totalWaitPayCount": 5,
        "totalCheckoutTotal": 250,
        "demandItems": [
            {
                "demandId": -1,
                "price": "50",
                "demandName": "综合服务"
            }
        ],
        "waitPayCount": 5,
        "deductAmount": 50,
        "checkoutTotal": 250,
        "remark": "",
        "rowSpan": 1
    },
    {
        "groupKey": "469_视频第4次交付",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2025-11-11T10:58:32.684Z",
        "deliveryVersion": "视频第4次交付",
        "totalWaitPayCount": 2,
        "totalCheckoutTotal": 100,
        "demandItems": [
            {
                "demandId": -1,
                "price": "50",
                "demandName": "综合服务"
            }
        ],
        "waitPayCount": 2,
        "deductAmount": 50,
        "checkoutTotal": 100,
        "remark": "",
        "rowSpan": 1
    },
    {
        "groupKey": "469_验证1121",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2025-11-26T02:02:17.98Z",
        "deliveryVersion": "验证1121",
        "totalWaitPayCount": 1,
        "totalCheckoutTotal": 20,
        "demandItems": [
            {
                "demandId": -1,
                "price": "20",
                "demandName": "综合服务"
            }
        ],
        "waitPayCount": 1,
        "deductAmount": 20,
        "checkoutTotal": 20,
        "remark": "",
        "rowSpan": 1
    },
    {
        "groupKey": "469_结算验证",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-01-15T07:47:14.679Z",
        "deliveryVersion": "结算验证",
        "totalWaitPayCount": 6,
        "totalCheckoutTotal": 405,
        "demandItems": [
            {
                "demandId": 5,
                "price": "50",
                "demandName": "tryon"
            }
        ],
        "waitPayCount": 3,
        "deductAmount": 50,
        "checkoutTotal": 150,
        "remark": "",
        "rowSpan": 2
    },
    {
        "groupKey": "469_结算验证",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-01-15T07:47:14.679Z",
        "deliveryVersion": "结算验证",
        "totalWaitPayCount": 6,
        "totalCheckoutTotal": 405,
        "demandItems": [
            {
                "demandId": 4,
                "price": "35",
                "demandName": "换脸"
            },
            {
                "demandId": 5,
                "price": "50",
                "demandName": "tryon"
            }
        ],
        "waitPayCount": 3,
        "deductAmount": 85,
        "checkoutTotal": 255,
        "remark": "",
        "rowSpan": 0
    },
    {
        "groupKey": "469_很多的图片",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-02-05T06:41:22.991Z",
        "deliveryVersion": "很多的图片",
        "totalWaitPayCount": 15,
        "totalCheckoutTotal": 0,
        "demandItems": [
            {
                "demandId": 8,
                "price": "0",
                "demandName": "3D图"
            }
        ],
        "waitPayCount": 15,
        "deductAmount": 0,
        "checkoutTotal": 0,
        "remark": "",
        "rowSpan": 1
    },
    {
        "groupKey": "469_合规图片验证",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-04T07:41:48.568Z",
        "deliveryVersion": "合规图片验证",
        "totalWaitPayCount": 2,
        "totalCheckoutTotal": 113,
        "demandItems": [
            {
                "demandId": 4,
                "price": "25",
                "demandName": "换脸"
            }
        ],
        "waitPayCount": 1,
        "deductAmount": 25,
        "checkoutTotal": 25,
        "remark": "",
        "rowSpan": 2
    },
    {
        "groupKey": "469_合规图片验证",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-04T07:41:48.568Z",
        "deliveryVersion": "合规图片验证",
        "totalWaitPayCount": 2,
        "totalCheckoutTotal": 113,
        "demandItems": [
            {
                "demandId": 7,
                "price": "88",
                "demandName": "换背景"
            }
        ],
        "waitPayCount": 1,
        "deductAmount": 88,
        "checkoutTotal": 88,
        "remark": "",
        "rowSpan": 0
    },
    {
        "groupKey": "469_合规信息-视频-111",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-04T09:22:28.808Z",
        "deliveryVersion": "合规信息-视频-111",
        "totalWaitPayCount": 2,
        "totalCheckoutTotal": 176,
        "demandItems": [
            {
                "demandId": 7,
                "price": "88",
                "demandName": "换背景"
            }
        ],
        "waitPayCount": 2,
        "deductAmount": 88,
        "checkoutTotal": 176,
        "remark": "",
        "rowSpan": 1
    },
    {
        "groupKey": "469_0305回归",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-05T08:15:57.793Z",
        "deliveryVersion": "0305回归",
        "totalWaitPayCount": 12,
        "totalCheckoutTotal": 445,
        "demandItems": [
            {
                "demandId": 5,
                "price": "25",
                "demandName": "tryon"
            }
        ],
        "waitPayCount": 2,
        "deductAmount": 25,
        "checkoutTotal": 50,
        "remark": "",
        "rowSpan": 4
    },
    {
        "groupKey": "469_0305回归",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-05T08:15:57.793Z",
        "deliveryVersion": "0305回归",
        "totalWaitPayCount": 12,
        "totalCheckoutTotal": 445,
        "demandItems": [
            {
                "demandId": 4,
                "price": "15",
                "demandName": "换脸"
            },
            {
                "demandId": 5,
                "price": "25",
                "demandName": "tryon"
            }
        ],
        "waitPayCount": 2,
        "deductAmount": 40,
        "checkoutTotal": 80,
        "remark": "",
        "rowSpan": 0
    },
    {
        "groupKey": "469_0305回归",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-05T08:15:57.793Z",
        "deliveryVersion": "0305回归",
        "totalWaitPayCount": 12,
        "totalCheckoutTotal": 445,
        "demandItems": [
            {
                "demandId": 7,
                "price": "30",
                "demandName": "换背景"
            }
        ],
        "waitPayCount": 3,
        "deductAmount": 30,
        "checkoutTotal": 90,
        "remark": "",
        "rowSpan": 0
    },
    {
        "groupKey": "469_0305回归",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-05T08:15:57.793Z",
        "deliveryVersion": "0305回归",
        "totalWaitPayCount": 12,
        "totalCheckoutTotal": 445,
        "demandItems": [
            {
                "demandId": 7,
                "price": "30",
                "demandName": "换背景"
            },
            {
                "demandId": 4,
                "price": "15",
                "demandName": "换脸"
            }
        ],
        "waitPayCount": 5,
        "deductAmount": 45,
        "checkoutTotal": 225,
        "remark": "",
        "rowSpan": 0
    },
    {
        "groupKey": "469_数据验证0317",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-17T05:50:42.669Z",
        "deliveryVersion": "数据验证0317",
        "totalWaitPayCount": 12,
        "totalCheckoutTotal": 1079,
        "demandItems": [
            {
                "demandId": 5,
                "price": "50",
                "demandName": "tryon"
            }
        ],
        "waitPayCount": 2,
        "deductAmount": 50,
        "checkoutTotal": 100,
        "remark": "",
        "rowSpan": 4
    },
    {
        "groupKey": "469_数据验证0317",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-17T05:50:42.669Z",
        "deliveryVersion": "数据验证0317",
        "totalWaitPayCount": 12,
        "totalCheckoutTotal": 1079,
        "demandItems": [
            {
                "demandId": 4,
                "price": "25",
                "demandName": "换脸"
            },
            {
                "demandId": 5,
                "price": "50",
                "demandName": "tryon"
            }
        ],
        "waitPayCount": 2,
        "deductAmount": 75,
        "checkoutTotal": 150,
        "remark": "",
        "rowSpan": 0
    },
    {
        "groupKey": "469_数据验证0317",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-17T05:50:42.669Z",
        "deliveryVersion": "数据验证0317",
        "totalWaitPayCount": 12,
        "totalCheckoutTotal": 1079,
        "demandItems": [
            {
                "demandId": 7,
                "price": "88",
                "demandName": "换背景"
            }
        ],
        "waitPayCount": 3,
        "deductAmount": 88,
        "checkoutTotal": 264,
        "remark": "",
        "rowSpan": 0
    },
    {
        "groupKey": "469_数据验证0317",
        "merchantId": 469,
        "merchantName": "百家好-新",
        "deliveredTime": "2026-03-17T05:50:42.669Z",
        "deliveryVersion": "数据验证0317",
        "totalWaitPayCount": 12,
        "totalCheckoutTotal": 1079,
        "demandItems": [
            {
                "demandId": 7,
                "price": "88",
                "demandName": "换背景"
            },
            {
                "demandId": 4,
                "price": "25",
                "demandName": "换脸"
            }
        ],
        "waitPayCount": 5,
        "deductAmount": 113,
        "checkoutTotal": 565,
        "remark": "",
        "rowSpan": 0
    }
]
const defaultBillId = ""
const defaultCreatedTime = ""
const defaultEnterpriseName = ""

// 下载结算单pdf
export const downloadPDF = (
    records=defaultRecords,
    billId=defaultBillId,
    createdTime=defaultCreatedTime,
    enterpriseName=defaultEnterpriseName,
    confirmIP="",
    confirmTime=""
) => {
    const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [794, 1123], // 794x1123
        // putOnlyUsedFonts: true,
        compress: true,
        floatPrecision: 16 // or "smart", default is 16
    })
    doc.setFont("helvetica")
    // 字体要比figma大4px
    const startX = 48
    let startY = 0
    // header
    const headHeight = 96
    doc.setFillColor(244, 247, 250);
    doc.rect(0, 0, 1123, headHeight, 'F')
    const imgLogo = new Image()
    imgLogo.src = logo
    doc.addImage(imgLogo, 'PNG', startX, 36.5, 60, 23)
    doc.setFontSize(24)
    doc.setTextColor(29, 41, 61);
    doc.text('PSAI业务交付结算确认单', 116, 56, {
        charSpace: 1.5
    })

    // info rect(1123, 134)
    const infoHeight = 134
    startY += headHeight
    doc.setTextColor(69, 85, 108);
    doc.setFontSize(18)
    doc.text('结算单编号：', startX, startY + 54)
    doc.text('结算单位：', startX, startY + 92)
    doc.setTextColor(15, 23, 43);
    doc.text(billId, startX + 120, startY + 54)
    doc.text(enterpriseName, startX + 120, startY + 92)
    // 结算日期背景
    doc.setDrawColor(226, 232, 240);
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(905, startY + 24, 170, 86, 10, 10, "FD");
    // 结算日期
    doc.setTextColor(69, 85, 108);
    doc.setFontSize(18)
    doc.text('结算日期', 905+25, startY + 60)
    doc.setTextColor(15, 23, 43);
    doc.setFontSize(26)
    doc.text(createdTime, 905+25, startY + 90)
    // 分割线
    doc.setLineWidth(1);
    doc.setDrawColor(202, 213, 226);
    doc.line(startX, startY + 134, 1123-startX, startY + 134)

    
    // table description
    const descHeight = 60
    startY += infoHeight
    doc.setTextColor(49, 65, 88);
    doc.setFontSize(18)
    doc.text('兹有本公司已按下表完成交付任务，并已递交至贵公司，交付清单如下：', startX, startY+26+17, {
        baseline: 'middle',
        lineHeightFactor: 2
    })
    

    // table
    startY += descHeight
    const maxDemandItemsLength = records.reduce((value, { demandItems }) => Math.max(value, demandItems.length), 0)
    const head = [[
        // "ID",
        "交付品牌", "交付日期", "交付批次",
        "加急数量",
        "总结算数量", "总结算金额(含税)", 
        ...Array.from({ length: maxDemandItemsLength }, (_, i) => `服务内容${i+1}`),
        "结算数量", "图片单价", "结算金额(含税)", "备注",
    ]]
    const getCellDef = (contnet, rowSpan, index, minCellWidth=50) => {
        if (rowSpan) {
            return {
                content: contnet,
                rowSpan,
                styles: {
                    fillColor: index % 2 === 1 ? [255, 255, 255] : [244, 247, 250],
                    minCellWidth,
                },
            }
        }
        return {
            content: contnet,
            styles: {
                fillColor: index % 2 === 1 ? [255, 255, 255] : [244, 247, 250],
                minCellWidth,
            },
        }
    }
    let index = 0
    const body = [
        ...records.map((item) => {
            const row = []
            if (item.rowSpan) index++
            // row.push(getCellDef(index, item.rowSpan, index)) // ID
            if (item.rowSpan) row.push(getCellDef(item.merchantName, item.rowSpan, index, 70))  // 交付品牌
            if (item.rowSpan) row.push(getCellDef(dayjs(item.deliveredTime).format("YYYY/MM/DD"), item.rowSpan, index, 80)) // 交付日期
            if (item.rowSpan) row.push(getCellDef(item.deliveryVersion, item.rowSpan, index, 70)) // 交付批次
            if (item.rowSpan) row.push(getCellDef(item.urgentNum, item.rowSpan, index, 80)) // 加急数量
            if (item.rowSpan) row.push(getCellDef(item.totalWaitPayCount, item.rowSpan, index, 80)) // 总结算数量
            if (item.rowSpan) row.push(getCellDef(`${item.totalCheckoutTotal}元`, item.rowSpan, index, 110)) // 总结算金额(含税) 
            row.push(
                ...Array.from({ length: maxDemandItemsLength }, (_, i) => getCellDef(item.demandItems[i]?.demandName || "", null, index, 74)) // 服务内容n
            )
            row.push(getCellDef(item.waitPayCount, null, index, 70)) // 结算数量
            row.push(getCellDef(`${item.deductAmount}元`, null, index, 70)) // 图片单价
            row.push(getCellDef(`${item.checkoutTotal}元`, null, index, 100)) // 结算金额(含税)
            if (item.rowSpan) row.push(getCellDef(item.remark, item.rowSpan, index)) // 备注

            return row
        })
    ]
    doc.setLineHeightFactor(1.25)
    autoTable(doc, {
        startY: startY,
        head,
        body,
        theme: 'striped',
        headStyles: { valign: 'middle', fontSize: 14, cellPadding: {top: 14, bottom:14, left: 10, right: 10}, minCellHeight: 40, fillColor: [236, 239, 242], textColor: [0, 0, 0], lineColor: 255, lineWidth: 1 },
        bodyStyles: { valign: 'middle', fontSize: 14, cellPadding: {top: 14, bottom:14, left: 10, right: 10}, minCellHeight: 40, },
        margin: { left: startX, right: startX, bottom: 22 },
        horizontalPageBreak: false,
        horizontalPageBreakRepeat: 0,
        horizontalPageBreakBehaviour: 'immediately',
        willDrawCell: function (data) {
            if (data.row.section === 'body') {
                // Set line style
                doc.setDrawColor(226, 232, 240); // Black
                doc.setLineWidth(1);
                // Draw bottom line: (x1, y1, x2, y2)
                doc.line(
                    data.cell.x, 
                    data.cell.y + data.cell.height, 
                    data.cell.x + data.cell.width, 
                    data.cell.y + data.cell.height
                );
            }
        },
    })

    // summary
    startY = doc.lastAutoTable.finalY
    const summaryHeight = 102
    if (startY + summaryHeight > doc.getPageHeight()) {
        doc.addPage()
        startY = 0
    }
    doc.setFontSize(22)
    doc.setLineHeightFactor(1) 
    doc.text('总价（含税）：', startX + 782, startY + 56)
    // 总价
    const checkoutTotal = uniqueByField(records, "groupKey").reduce((value, { totalCheckoutTotal }) => value + totalCheckoutTotal, 0)
    doc.setFontSize(34)
    doc.text(`${checkoutTotal}元`, startX + 912, startY + 58)

    // signature
    startY += summaryHeight
    const signHeight = 196
    if (startY + signHeight > doc.getPageHeight()) {
        doc.addPage()
        startY = doc.getPageHeight() - signHeight
    } else {
        startY = doc.getPageHeight() - signHeight
    }
    doc.setFillColor(244, 247, 250);
    doc.rect(0, startY, 1123, signHeight, 'F')
    doc.setFontSize(20)
    doc.text('衷心感谢您的信赖，请您确认上述服务已完成并签收。', startX, startY + 56)
    doc.text('结算单位（签字）：', startX, startY + 113)
    doc.text('签收日期：', startX + 537.5, startY + 113)
    doc.setLineWidth(2);
    doc.setDrawColor(202, 213, 226)
    doc.line(startX, startY + 169, startX + 490, startY + 169)
    doc.line(startX + 537.5, startY + 169, startX + 537.5 + 490, startY + 169)

    // 确认IP
    if (confirmIP) {
        doc.setFontSize(32)
        doc.text(confirmIP, startX + 200, startY + 160)
    }
    
    // 确认时间
    if (confirmTime) {
        doc.text(dayjs(confirmTime).format("YYYY/MM/DD HH:mm:ss"), startX + 737.5, startY + 160)
    }

    return doc
}